<span style="font-size: 1.2em; font-weight: bold;" class="d-block">{{ step3.getspan17 | translate }}</span>
<br />

<app-typeCPV-class
	[uid]="getUid()"
	[parentForm]="parentForm"

	[disabled]="disabled"
	[objetPrincipal]="codeCPV?.objetPrincipal"
  [i]="i"
  (prefEmit)="chargeDonneePreference($event)"
>
</app-typeCPV-class>
